<template>
  <header class="site-header">
    <nav class="axum-navbar" aria-label="Navegación principal">
      <router-link class="brand-link" to="/" @click="closeMobile">
        <img src="@/assets/logo-new.png" alt="AXUM S. de R.L." class="brand-logo" />
      </router-link>

      <div class="nav-links" aria-label="Rutas principales">
        <router-link exact-active-class="active" class="nav-route" to="/">Home</router-link>
        <router-link
          class="nav-route"
          :class="{ active: isProductsRoute }"
          to="/productos"
        >
          Productos
        </router-link>
        <router-link
          class="nav-route"
          :class="{ active: isCotizacionRoute }"
          to="/cotizacion"
        >
          Cotizacion
        </router-link>
      </div>

      <div class="nav-actions">
        <a
          href="https://www.instagram.com/axum.hn/"
          target="_blank"
          rel="noopener noreferrer"
          class="social-link"
          aria-label="Instagram de AXUM"
        >
          <i class="fa-brands fa-instagram"></i>
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61579514042802&amp;sk=reels_tab"
          target="_blank"
          rel="noopener noreferrer"
          class="social-link"
          aria-label="Facebook de AXUM"
        >
          <i class="fa-brands fa-facebook-f"></i>
        </a>
        <a
          href="https://wa.me/50498855803"
          target="_blank"
          rel="noopener noreferrer"
          class="social-link"
          aria-label="WhatsApp de AXUM"
        >
          <i class="fa-brands fa-whatsapp"></i>
        </a>
      </div>

      <button
        id="btnMobileNav"
        class="mobile-toggle"
        type="button"
        :aria-expanded="mobileOpen.toString()"
        aria-controls="bot-nav"
        aria-label="Abrir menú"
        @click="mobileOpen = !mobileOpen"
      >
        <i :class="mobileOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'"></i>
      </button>
    </nav>

    <div
      id="bot-nav"
      class="mobile-panel"
      :class="{ 'd-none': !mobileOpen, mostrar: mobileOpen }"
    >
      <router-link exact-active-class="active" class="mobile-route" to="/" @click="closeMobile">
        Home
      </router-link>
      <router-link
        class="mobile-route"
        :class="{ active: isProductsRoute }"
        to="/productos"
        @click="closeMobile"
      >
        Productos
      </router-link>
      <router-link
        class="mobile-route"
        :class="{ active: isCotizacionRoute }"
        to="/cotizacion"
        @click="closeMobile"
      >
        Cotizacion
      </router-link>
      <a
        href="https://www.instagram.com/axum.hn/"
        target="_blank"
        rel="noopener noreferrer"
        class="mobile-social"
        aria-label="Instagram de AXUM"
      >
        <i class="fa-brands fa-instagram"></i>
        Instagram
      </a>
      <a
        href="https://www.facebook.com/profile.php?id=61579514042802&amp;sk=reels_tab"
        target="_blank"
        rel="noopener noreferrer"
        class="mobile-social"
        aria-label="Facebook de AXUM"
      >
        <i class="fa-brands fa-facebook-f"></i>
        Facebook
      </a>
      <a
        href="https://wa.me/50498855803"
        target="_blank"
        rel="noopener noreferrer"
        class="mobile-social"
        aria-label="WhatsApp de AXUM"
      >
        <i class="fa-brands fa-whatsapp"></i>
        WhatsApp
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderApp',
  data() {
    return {
      mobileOpen: false,
    }
  },
  computed: {
    isProductsRoute() {
      return this.$route.path.startsWith('/productos') || this.$route.path.startsWith('/producto')
    },
    isCotizacionRoute() {
      return this.$route.path.startsWith('/cotizacion')
    },
  },
  watch: {
    $route() {
      this.closeMobile()
    },
  },
  methods: {
    closeMobile() {
      this.mobileOpen = false
    },
  },
}
</script>

<style scoped>
.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.92);
  border-bottom: 1px solid rgba(219, 219, 219, 0.9);
  backdrop-filter: blur(18px);
}

.axum-navbar {
  min-height: 76px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 24px;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 28px;
}

.brand-link {
  display: inline-flex;
  align-items: center;
  width: fit-content;
}

.brand-logo {
  width: 164px;
  height: auto;
  display: block;
}

.nav-links {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px;
  border: 1px solid #dbdbdb;
  border-radius: 999px;
  background-color: #ffffff;
}

.nav-route,
.mobile-route,
.mobile-social {
  color: #434341;
  text-decoration: none;
  font-family: "Montserrat", sans-serif;
  font-size: 0.94rem;
  font-weight: 700;
  line-height: 1;
}

.nav-route {
  min-width: 112px;
  padding: 12px 20px;
  border-radius: 999px;
  text-align: center;
  transition: background-color 180ms ease, color 180ms ease, box-shadow 180ms ease;
}

.nav-route:hover,
.nav-route.active {
  color: #ffffff;
  background-color: #14213d;
  box-shadow: 0 10px 24px rgba(20, 33, 61, 0.16);
}

.nav-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.social-link {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #14213d;
  text-decoration: none;
  border: 1px solid #dbdbdb;
  border-radius: 50%;
  background-color: #ffffff;
  transition: color 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.social-link:hover {
  color: #0a3d91;
  border-color: #f4ba56;
  transform: translateY(-2px);
}

.mobile-toggle {
  display: none;
  justify-self: end;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  color: #14213d;
  border: 1px solid #dbdbdb;
  border-radius: 50%;
  background-color: #ffffff;
}

.mobile-panel {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px 18px;
  background-color: #ffffff;
}

.mobile-route,
.mobile-social {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  background-color: #ffffff;
}

.mobile-route.active {
  color: #ffffff;
  border-color: #14213d;
  background-color: #14213d;
}

@media (max-width: 768px) {
  .axum-navbar {
    grid-template-columns: 1fr auto;
    min-height: 68px;
    padding: 0 18px;
  }

  .brand-logo {
    width: 136px;
  }

  .nav-links,
  .nav-actions {
    display: none;
  }

  .mobile-toggle {
    display: inline-flex;
  }
}
</style>
